import { render, staticRenderFns } from "./MarketingMenu.vue?vue&type=template&id=1fcd0627&"
import script from "./MarketingMenu.vue?vue&type=script&lang=js&"
export * from "./MarketingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports